// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"controlButton___2I9yy","buttonWrap":"buttonWrap___3Ft_j","login":"login___1Mc49","register":"register___1Z4S6","loggedInMenu":"loggedInMenu___1MblE"};